import withLayout from '../../hocs/Layout'
import { Box } from '@mui/material'
import PageTitle from '../../common/PageTitle'
import { pageContainerSx } from '../../styles/patterns'
import NDRCall from './NDRCalls'

// Standalone route for the existing Call Recordings table (wired to NDR_RECORDING_SEARCH).
const CallRecordings = () => (
  <Box sx={pageContainerSx}>
    <PageTitle subTitle='Review NDR call recordings, outcomes and responses'>Call Recordings</PageTitle>
    <NDRCall />
  </Box>
)

export default withLayout(CallRecordings)
